import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete.tsx';
import { MetacategoryGroup, type MetacategoryGroupType } from '@openx/types/targeting/metacategory.ts';
import { useTranslation } from 'react-i18next';
import { useTargetingOptionDisabledState } from '../../../utils/hooks/useTargetingOptionDisabledState.ts';

type InventoryContentOptionDropdownProps = {
  onChange: (type: MetacategoryGroupType) => void;
  value: MetacategoryGroupType;
};

export const MetacategoryGroupOptionDropdown = (props: InventoryContentOptionDropdownProps) => {
  const { onChange, value } = props;
  const { t } = useTranslation();
  const { isOptionDisabled } = useTargetingOptionDisabledState();

  const labels: Record<MetacategoryGroupType, string> = {
    [MetacategoryGroup.ADDITIONAL_OPENX_CATEGORIES]: t('OpenX Categories'),
    [MetacategoryGroup.KEYWORDS]: t('Keywords'),
  };

  return (
    <AutoComplete
      textFieldProps={{ label: t('Type') }}
      options={Object.keys(labels)}
      renderOptions={{
        dataTest: 'type-option',
      }}
      getOptionLabel={option => labels[option]}
      getOptionDisabled={option => isOptionDisabled(option)}
      textFieldReadOnly
      disableClearable
      onChange={(_, value) => onChange(value as MetacategoryGroupType)}
      value={value}
      data-test="metacategory-category-type"
    />
  );
};
